import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import { ProductSearch } from '../dto/product/ProductSearch';
import { ApiClient } from '../util/ApiUtility';
import { ProductDetailEntity } from '../dto/product/ProductDetailEntity';

export const onProductDetail = async (id: number) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
        'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/product/' + id
    }
    const response = await ApiClient().request<BaseResponse<ProductDetailEntity>>(requestConfig);

    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onProductSearch = async (data: ProductSearch) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/product',
        params: {
            title: data.title,
            categoryIds: data.categoryIds && data.categoryIds.length > 0 ? data.categoryIds.join(',') : null,
            brandIds: data.brandIds && data.brandIds.length > 0 ? data.brandIds.join(',') : null,
            offset: data.offset,
            limit: data.limit
        }
    }
    const response = await ApiClient().request<ReadResponse>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onProduct = async (productId: string) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/product',
            params: {
            id: productId
        }
    }
    const productResponse = await ApiClient().request<ReadResponse>(requestConfig);
    if (productResponse.status >= 200 && productResponse.status < 300) {
        return productResponse.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onProductBidHistory = async (productId: string) => {
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
        url: `${URL_BACKEND_ROOT}` + '/v1/cms/product/bid-history',
        params: {
            productIds: productId
        }
    }
    const productBidHistoryResponse = await ApiClient().request<ReadResponse>(requestConfig);
    if (productBidHistoryResponse.status >= 200 && productBidHistoryResponse.status < 300) {
        return productBidHistoryResponse.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}